import React from "react";
import {
  HeaderContainer,
  HeaderTitle,
  ButtonGroup,
  CancelButton,
  ContinueButton,
} from "./header.styles";

interface NewOfferingHeaderProps {
  title: string;
  onCancel?: () => void;
  onContinue?: () => void;
  canContinue?: boolean;
}

export const NewOfferingHeader: React.FC<NewOfferingHeaderProps> = ({
  title,
  onCancel,
  onContinue,
  canContinue = false,
}) => {
  return (
    <HeaderContainer>
      <HeaderTitle>{title}</HeaderTitle>
      <ButtonGroup>
        <CancelButton onClick={onCancel}>Cancel</CancelButton>
        <ContinueButton onClick={onContinue} disabled={!canContinue}>
          Continue
        </ContinueButton>
      </ButtonGroup>
    </HeaderContainer>
  );
};
